import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';

export default function GuestGuard({ children }) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitialized) return;

    if (isLoggedIn) {
      navigate(DASHBOARD_PATH, { replace: true });
    }
  }, [isLoggedIn, isInitialized, navigate]);

  if (!isInitialized) return null;

  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };